<!--
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-05-28 16:57:42
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-05-28 16:57:51
 -->
<template>
  <div id="the-head">
    <TheBreadcrumb class="the-breadcrumb" />
    <!-- <div class="head-right">
      <el-badge :value="99" :hidden="false" :max="99" class="badge-content">
        <img src="/static/img/layout/info.png">
      </el-badge>
      <span class="vertical-line"></span>
      <img src="/static/img/layout/user.png" class="user-icon">
      <TheDropdown class="the-dropdown" />
    </div> -->
  </div>
</template>

<script>
// import TheDropdown from '@/components/TheDropdown'
import TheBreadcrumb from '@/components/TheBreadcrumb'

export default {
  name: 'TheHead',
  components: {
    // TheDropdown,
    TheBreadcrumb,
  },
}
</script>

<style lang="less" scoped>
#the-head {
  height: 55px;
  padding-left: 18px;
  padding-right: 32px;
  border-bottom: 1px solid #e0e0e0;

  .the-breadcrumb {
    display: inline-block;
    height: 55px;
    overflow: hidden;
    line-height: 55px;

    /deep/ .el-breadcrumb__inner {
      color: #666;
      font-weight: normal;
    }
  }

  .head-right {
    float: right;

    .badge-content {
      margin-top: -41px;
    }

    .vertical-line {
      display: inline-block;
      width: 2px;
      background: #666;
      height: 20px;
      vertical-align: 16px;
      margin-right: 20px;
      margin-left: 25px;
    }

    .user-icon {
      width: 30px;
      height: 30px;
      margin-right: 14px;
      vertical-align: 12px;
    }

    .the-dropdown {
      height: 55px;
      overflow: hidden;
      line-height: 55px;

      /deep/ .el-breadcrumb__inner {
        color: #666;
        font-weight: normal;
      }
    }
  }
}
</style>
